import { Fragment } from 'react';
import { Button } from '../../atoms/Button';
import { Icon } from '../../atoms/Icon';

export interface BreadcrumbsItem {
  label: string;
  href: string;
  onClick?: () => void;
}

interface BreadcrumbsProps {
  items: BreadcrumbsItem[];
  className?: string;
}

function Breadcrumbs({ items, className }: BreadcrumbsProps) {
  if (!items || items.length === 0) {
    return <></>;
  }

  return (
    <nav className={className}>
      <ul className='flex items-center'>
        {items.map((item, index) => (
          <Fragment key={index}>
            <li key={item.href} className='group'>
              <Button
                allowReadOnly
                variant='text'
                onClick={() => item.onClick && item.onClick()}
                size='small'
                disabled={index === items.length - 1}
                className='group-first:pl-0'
                asLink
                to={item.href}
              >
                {item.label}
              </Button>
            </li>
            {index !== items.length - 1 && (
              <Icon
                type='material'
                Icon='chevron_right'
                className='text-base text-mono-color-black'
                key={`chevron-${index}`}
              />
            )}
          </Fragment>
        ))}
      </ul>
    </nav>
  );
}

export { Breadcrumbs };
